// Dialog Box for creating / updating Note -  Pop-up
import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
    Grid, MenuItem, Menu, ListItemText, Button,
    TextField, InputAdornment
  } from "@mui/material";
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';
import Tooltip from '@mui/material/Tooltip';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CheckIcon from '@mui/icons-material/CheckBoxRounded';
import SearchIcon from "@mui/icons-material/Search";
import { getDPList } from "../../actions/Users/authenticateInventory";
import "./inventoryWarehouse.css"
import _ from "lodash";
import { getOu, getOuforReports, getUserOu, populateForParent } from "../../utils/util";
var Loader = require("react-loader");


const DP_Dropdown = (props) => {
  const {  authReducer, getDPList, isSmall=false, setOu, className, deviceOu, isReports, height, width, maxWidth, dropdownMenuWidth } = props;

  const [organisations, setOrganisations] = useState<any[]>([]);
  const [selectedOu, setSelectedOu] = useState(_.isEmpty(deviceOu)?authReducer.selectedOu:deviceOu);
  const [loading, setLoading] = useState<Boolean>(false);
  const [showOuList, setShowOuList] = useState(true);
  const [ouSearchValue, setOuSearchValue] = useState("");
  const [isOuClicked, setIsOuClicked] = useState<Boolean>(false);
  const [newOrganisationsList, setNewOrganisationsList] = useState<any>([]);
 
  useEffect(() => {
    setOu(selectedOu)
    setOuName(selectedOu?.name);
  }, [selectedOu])

useEffect(() => {
  if (authReducer.selectedOu && authReducer.selectedOu?.name) {
    setOrganisations([authReducer?.selectedOu]);
  }
  getDPList();
}, []);


const handleOuClose = (popupState: any = null) => {
  if (popupState) {
    popupState.close();
  }
  if (_.isEmpty(organisations)) {
    getDPList();
  }

  if (!isOuClicked && ouSearchValue) {
    setOuSearchValue("");
    getDPList();
  }
}

const handleOuSearch = async (value) => {
    setOuSearchValue(value);
    setLoading(true);
    // getDPList(value);
  }


const searchOu = (tree, ouName) => {
  if (tree && ouName) {
    for (let i = 0; i < tree.length; i++) {
      if (tree[i].name === ouName) {
        return tree[i];
      }
      if (tree[i].parent_of) {
        let ou = searchOu(tree[i].parent_of, ouName);
        if (ou) return ou;
      }
    }
  }
  return null;
}

  const searchOuList = (data, searchValue) => {
    const recursiveSearch = (arr) => {
      let result: any = [];
      for (let item of arr) {
        let children: any = [];
        if (item.parent_of && item.parent_of.length > 0) {
          children = recursiveSearch(item.parent_of);
        }
        if (item.name.toLowerCase().includes(searchValue.toLowerCase()) || children.length > 0) {
          result.push({
            name: item.name,
            id: item.id,
            _childern: children
          });
        }
      }
      return result;
    }
    const ouList = {
      name: data.name,
      id: data.id,
      _childern: recursiveSearch(data.parent_of)
    };

    return ouList;
  }

useEffect(() => {
    if (loading) {
        setLoading(false);
    }
    if (!_.isEmpty(authReducer.getDPList) && authReducer.getDPList.dps && authReducer.getDPList.dps.length > 0 && ouSearchValue) {
      const ouList = authReducer.getDPList.dps[0];
      const result = searchOuList(ouList, ouSearchValue);
      setNewOrganisationsList([result]);
    }
    else if (authReducer.getDPList && authReducer.getDPList.dps) {
        let _organisations: any[] = [];
        if (authReducer.getDPList.dps && authReducer.getDPList.dps.length > 0 ) {
          authReducer.getDPList.dps.map((item) => {
            _organisations = populateForParent(item, null, _organisations);
          })
        }
        setOrganisations(_organisations);
        setSelectedOu(isReports ? getOuforReports(_organisations,selectedOu,authReducer.getDPList) :getOu(_organisations,selectedOu,authReducer.getDPList))
        // authReducer.getDPList = {};
    }
}, [authReducer.getDPList, ouSearchValue]);

const handleOuClick = (event, ou, popupState) => { 
    if (popupState) {
      popupState.close();
    }
    setIsOuClicked(true);
    setSelectedOu(ou)
    if(ouSearchValue){
      setOuSearchValue("");
      // getDPList();
    }
  };

  interface PopupState {
    // Define the structure of popupState if needed
  }

  interface OuItem {
    id: string;
    name: string;
    _childern: OuItem[];
  }

  const [visibleItems, setVisibleItems] = useState<{ [key: string]: boolean }>({});
  const [ouName, setOuName] = useState(authReducer?.selectedOu?.name ? authReducer.selectedOu.name : '');

  const handleToggleVisibility = (key: string) => {
    setVisibleItems(prevState => ({ ...prevState, [key]: !prevState[key] }));
  };

  const getOuTree = (popupState: PopupState, ous: OuItem[], prefix: string = ""): React.ReactNode[] => {
    let list: React.ReactNode[] = [];
    if (ous && Array.isArray(ous)) {
      for (let i = 0; i < ous.length; i++) {
        const item = ous[i];
        const key = prefix + i;
        // const isVisible = visibleItems[key] || false;
        let isVisible = prefix === "" ? true : visibleItems[key] || false;
        if (ouSearchValue) {
          isVisible = true
        }
        const _children = getOuTree(popupState, item._childern || [], key + "_");
        list.push(
          <div key={key + 'div'} style={{ background: "#ffffff" }}>
            <Tooltip placement="left" title={<span className="span_NewSummary">{item.name}</span>} arrow>
              <MenuItem
                key={key}
                className="OuMenuChild"

              >
                <span className="plusMinusIc" onClick={(e) => { e.stopPropagation(); handleToggleVisibility(key); }}>
                  {item._childern && item._childern.length > 0 ? (isVisible ? "-" : "+") : "-"}
                </span>
                <ListItemText primary={item.name} className="childHierarch textWrapInner" onClick={(e) => handleOuClick(e, item, popupState)} />
                {ouName === item.name && <CheckIcon style={{ background: "#474444", fontSize: "12px" }} />}
              </MenuItem>
            </Tooltip>
            {isVisible && (
              <div key={key + 'childern'} className="childern">
                {_children}
              </div>
            )}
          </div>
        );
      }
    }
    return list
  }

return (
    <div className="Form">
        <Grid>
        {
            showOuList ?
            <Grid className="DPvesselDropdown" sx={{ marginRight: "15px !important" }}>
                <PopupState variant="popover" popupId="ou-popup-menu">
                {(popupState) => (
                    <React.Fragment>
                    <Button className={`DPVesselName ${className}`} variant="contained" {...bindTrigger(popupState)}   disabled={isReports ? true : false} sx={{height: height, width: width, maxWidth: maxWidth, padding: "0px 10px !important", fontSize: "12px", fontFamily: "Inter", fontWeight: 500, lineHeight: "10px", letterSpacing: "0%", color: "#45464E", backgroundColor: "#F5F5F5", borderRadius: "4px", border: "1px solid #D0D1DC", "&:hover": { backgroundColor: "#F5F5F5" }, marginTop: "-2px" }} >
                        <span className="DPtextWrap inviteUserOrg" title={!_.isEmpty(selectedOu) && selectedOu.hasOwnProperty("name")? selectedOu["name"] :""}>{!_.isEmpty(selectedOu) && selectedOu.hasOwnProperty("name")? selectedOu["name"] :""}</span>
                {!isReports && <>{
                        popupState.isOpen ?
                            <ArrowDropDownIcon key="ouArrow" className="DPdropdownArrow margin-left-auto" style={{ cursor: "pointer", transform: "rotate(-180deg)" }} sx={{ marginRight: "-11px" }} />
                            :
                            <ArrowDropDownIcon key="ouArrow" className="DPdropdownArrow margin-left-auto" sx={{ marginRight: "-11px" }} />
                        }</>}
                    </Button>
                    <Menu 
                    {...bindMenu(popupState)}
                        id={isSmall ? "DPmenuSmall-ou" : className ? "dpDropdownMenu-ou" : "DPmenu-ou"}
                        aria-labelledby="menu-ou"
                        onClose={() => handleOuClose(popupState)}
                        key="menu-ou"
                        className="childHierarchy"
                        sx={{
                          "& .MuiPaper-root": {
                            width: dropdownMenuWidth ? `${dropdownMenuWidth} !important` : '342px',
                          },
                        }}
                    >
                      <MenuItem key={'ou_text'} className="vessel_search_item vessel_search_item" onKeyDown={(e) => e.stopPropagation()}>
                        <TextField
                          id="ousearchtext"
                          variant="outlined"
                          placeholder="Type something"
                          autoComplete="off"
                          size="small"
                          value={ouSearchValue}
                          onChange={(event) => {
                            handleOuSearch(event.target.value);
                          }}
                          InputLabelProps={{ className: "serachLabel" }}
                          InputProps={{
                            className: "serachBar",
                            startAdornment: (
                              <InputAdornment position="start">
                                <SearchIcon style={{ position: "absolute", right: "12px", fontSize: "12px" }} className="cursorPointer" />
                              </InputAdornment>
                            ),
                          }}
                        />
                      </MenuItem>
                        <span>
                        {getOuTree(popupState, ouSearchValue ? newOrganisationsList : organisations)}</span>
                    </Menu>

                    </React.Fragment>
                )}
                </PopupState>
            </Grid>
            : <></>
        }
        {/* {
        loading ? (
          <div style={{ position: "absolute", top: "63px", right: "36px" }}>
            <Loader radius={4} length={5} lines={10} width={2} color={"#264C86"} />
          </div>
          ) : <></>
        } */}
        </Grid>
    </div>
  );
}

const mapStateToProps = (state) => ({
    authReducer: state.authReducer,
    errorReducer: state.errorReducer,
});
export default withRouter(
    connect(mapStateToProps, {
     getDPList
    })(DP_Dropdown)
);